(function(){
  var script=document.getElementById('gc-consent-sync'),privacy,loaded=false;
  if(!script)return;
  function sync(){
    if(!privacy)return;
    var consent=privacy.currentVisitorConsent();
    var analytics=consent.analytics==='yes'&&privacy.analyticsProcessingAllowed();
    var marketing=consent.marketing==='yes'&&privacy.marketingAllowed();
    script.dataset.analyticsConsent=analytics?'granted':'denied';
    script.dataset.marketingConsent=marketing?'granted':'denied';
    window.gtag('consent','update',{analytics_storage:analytics?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing?'granted':'denied'});
    if(analytics&&marketing&&!loaded&&script.dataset.gtmId){
      loaded=true;
      window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
      var tag=document.createElement('script');tag.async=true;tag.src='https://www.googletagmanager.com/gtm.js?id='+encodeURIComponent(script.dataset.gtmId);document.head.appendChild(tag);
    }
  }
  function ready(error){if(error||!(window.Shopify&&window.Shopify.customerPrivacy))return;privacy=window.Shopify.customerPrivacy;sync();}
  document.addEventListener('visitorConsentCollected',function(){if(privacy)sync();});
  if(window.Shopify&&window.Shopify.customerPrivacy){ready();}
  else if(window.Shopify&&window.Shopify.loadFeatures){window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],ready);}
})();

